















































import { IPage, questionTypeName } from '@/types/questionnaire'
import { computed, defineComponent } from '@vue/composition-api'
import { QuestionEntity } from '../../../../api/@types'

type Props = {
  page: IPage
  question: QuestionEntity
  isAutomatic: boolean
}

export default defineComponent({
  name: 'QuestionRow',
  props: {
    page: {
      type: Object,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
    isAutomatic: {
      type: Boolean,
      default: true,
    },
  },
  setup(props: Props, context) {
    const store = context.root.$store
    const orderText = computed(
      () => `${props.page.order}-${props.question.order}`,
    )
    const typeText = computed(() => questionTypeName(props.question.type))
    const qId = context.root.$route.params.id

    const onUp = () => {
      store.dispatch('questionnaire/changeQuestionOrder', {
        pageId: props.page.id,
        questionId: props.question.id,
        type: 'up',
      })
    }

    const onDown = () => {
      store.dispatch('questionnaire/changeQuestionOrder', {
        pageId: props.page.id,
        questionId: props.question.id,
        type: 'down',
      })
    }

    const disabledUp = computed(() => props.question.order === 1)
    const disabledDown = computed(
      () => props.question.order === props.page.questions.length,
    )

    const visibleAddCondition = computed(() =>
      ['radio', 'checkbox'].includes(props.question.type),
    )

    const qType = props.isAutomatic ? 'automatic' : 'manual'

    return {
      qId,
      orderText,
      typeText,
      disabledUp,
      disabledDown,
      visibleAddCondition,
      onUp,
      onDown,
      qType,
    }
  },
})
